export const ncmOptions = [
  { value: "23091000", label: "23091000 - Alimentos completos para cães ou gatos" },
  { value: "23099090", label: "23099090 - Outras preparações para alimentação animal" },
  { value: "30049099", label: "30049099 - Medicamentos para uso veterinário (outros)" },
  { value: "30043900", label: "30043900 - Medicamentos contendo outros antibióticos" },
  { value: "30049010", label: "30049010 - Medicamentos veterinários (antiparasitários)" },
  { value: "30059090", label: "30059090 - Outros artefatos e artigos para uso veterinário" },
  { value: "35079090", label: "35079090 - Enzimas e preparações enzimáticas" },
  { value: "38089290", label: "38089290 - Outros inseticidas/carrapaticidas para uso veterinário" },
  { value: "38089190", label: "38089190 - Outros inseticidas" },
  { value: "38089920", label: "38089920 - Produtos veterinários (repelentes, sanitizantes)" },
  { value: "33071000", label: "33071000 - Preparações para barbear (shampoos pet)" },
  { value: "33051000", label: "33051000 - Xampus para animais" },
  { value: "33049990", label: "33049990 - Outros produtos de beleza e higiene para animais" },
  { value: "90189099", label: "90189099 - Outros instrumentos e aparelhos para uso veterinário" },
  { value: "90211000", label: "90211000 - Aparelhos ortopédicos para animais" },
  { value: "39269090", label: "39269090 - Outras obras de plástico (coleiras, brinquedos)" },
  { value: "42010000", label: "42010000 - Artigos de selaria e correaria para animais" },
  { value: "94019000", label: "94019000 - Partes de assentos (camas e cestas para pets)" },
  { value: "63049990", label: "63049990 - Outros artigos de cama e similares (cobertores pet)" },
  { value: "40159000", label: "40159000 - Vestuário para animais de borracha" },
  { value: "61171000", label: "61171000 - Xales, echarpes, cachecóis para animais (malha)" },
  { value: "84219900", label: "84219900 - Partes de aparelhos filtrantes (bebedouros automáticos)" },
  { value: "84798990", label: "84798990 - Outras máquinas e aparelhos (tosadeiras elétricas)" },
  { value: "85094000", label: "85094000 - Aparelhos eletromecânicos (tosadeiras domésticas)" },
  { value: "05119910", label: "05119910 - Produtos de origem animal (sêmen bovino/canino)" },
];

export const cfopOptions = [
  { value: "5102", label: "5102 - Venda de mercadoria adquirida (intraestadual)" },
  { value: "5101", label: "5101 - Venda de produção própria (intraestadual)" },
  { value: "5405", label: "5405 - Venda com substituição tributária (intraestadual)" },
  { value: "5933", label: "5933 - Prestação de serviço tributada pelo ISSQN" },
  { value: "5949", label: "5949 - Outra saída de mercadoria (intraestadual)" },
  { value: "6102", label: "6102 - Venda de mercadoria adquirida (interestadual)" },
  { value: "6101", label: "6101 - Venda de produção própria (interestadual)" },
  { value: "6404", label: "6404 - Venda com substituição tributária (interestadual)" },
  { value: "6949", label: "6949 - Outra saída de mercadoria (interestadual)" },
  { value: "5202", label: "5202 - Devolução de compra de mercadoria adquirida" },
  { value: "6202", label: "6202 - Devolução de compra interestadual" },
];

export const originOptions = [
  { value: "0", label: "0 - Nacional" },
  { value: "1", label: "1 - Estrangeira — importação direta" },
  { value: "2", label: "2 - Estrangeira — adquirida no mercado interno" },
  { value: "3", label: "3 - Nacional — conteúdo importado > 40%" },
  { value: "4", label: "4 - Nacional — conforme processos básicos" },
  { value: "5", label: "5 - Nacional — conteúdo importado ≤ 40%" },
  { value: "6", label: "6 - Estrangeira — importação direta sem similar nacional" },
  { value: "7", label: "7 - Estrangeira — mercado interno sem similar nacional" },
  { value: "8", label: "8 - Nacional — conteúdo importado > 70%" },
];

export const icmsOptions = [
  { value: "102", label: "102 - Simples Nacional sem crédito" },
  { value: "101", label: "101 - Simples Nacional com crédito" },
  { value: "103", label: "103 - Simples Nacional — isenção por faixa de receita" },
  { value: "300", label: "300 - Imune" },
  { value: "400", label: "400 - Não tributada pelo Simples Nacional" },
  { value: "500", label: "500 - ICMS cobrado anteriormente por substituição" },
  { value: "900", label: "900 - Outros (Simples Nacional)" },
  { value: "00",  label: "00 - Tributada integralmente (Regime Normal)" },
  { value: "20",  label: "20 - Tributada com redução de base de cálculo" },
  { value: "40",  label: "40 - Isenta" },
  { value: "41",  label: "41 - Não tributada" },
  { value: "60",  label: "60 - ICMS cobrado anteriormente por ST" },
];

export const pisCofinsOptions = [
  { value: "01", label: "01 - Operação tributável (alíquota básica)" },
  { value: "04", label: "04 - Monofásica — revenda a alíquota zero" },
  { value: "05", label: "05 - Substituição tributária" },
  { value: "06", label: "06 - Alíquota zero" },
  { value: "07", label: "07 - Isenta da contribuição" },
  { value: "08", label: "08 - Sem incidência da contribuição" },
  { value: "49", label: "49 - Outras saídas" },
];

export const ibsCbsSituationOptions = [
  { value: "000", label: "000 - Tributação integral" },
  { value: "010", label: "010 - Alíquotas uniformes" },
  { value: "200", label: "200 - Redução de alíquota" },
  { value: "400", label: "400 - Isenção" },
];

export const ibsCbsClassOptions = [
  { value: "000001", label: "000001 - Regra geral" },
  { value: "000002", label: "000002 - Exportação" },
];

export const unitOptions = [
  { value: "UN", label: "UN — Unidade" },
  { value: "CX", label: "CX — Caixa" },
  { value: "PCT", label: "PCT — Pacote" },
  { value: "KG", label: "KG — Quilograma" },
  { value: "G",  label: "G — Grama" },
  { value: "L",  label: "L — Litro" },
  { value: "ML", label: "ML — Mililitro" },
  { value: "MG", label: "MG — Miligrama" },
];

export { saoPauloServiceListOptions as serviceListItemOptions } from "@/lib/fiscal/nfse/sao-paulo-service-list";
